// fastContext.ts
'use client';
import createFastContext from '../context/createFastContext';

export const { FastContextProvider:ReportFastContextProvider, useFastContextFields: useGlobalReportContext } =
  createFastContext({
    openReportSheet: false,
    reportIndex:0
  });
